/*
  FAIRYLAND JEWELS — konverzní chování
  1) Upsell na produktovce: zaškrtnuté doplňky (krabička, ochrana zásilky)
     se přidají do košíku hned po úspěšném přidání prstenu.
  2) Upsell v cart draweru: tlačítka „Přidat“ pro doplňky.
  3) Sticky nákupní lišta na mobilu.
  4) Dynamický termín doručení („Objednáš dnes → v úterý ji má na ruce“).
*/

(function () {
  'use strict';

  /* ---------- pomocné: přidání položek + překreslení draweru ---------- */

  function addItemsToCart(items, onDone) {
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        // Sekce si vyžádáme zvlášť od aktuální stránky. /cart/add.js na tomto
        // obchodě vrací sections: null, takže by košík zůstal neaktuální —
        // zákazník by po přidání doplňku viděl starou cenu.
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(
          function (response) {
            return response.json();
          }
        );
      })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.renderContents({ sections: sections });
        if (onDone) onDone();
      })
      .catch(function (error) {
        console.error('[fairyland] přidání doplňku selhalo', error);
        if (onDone) onDone();
      });
  }

  /* ---------- 1) upsell na produktovce ---------- */

  function collectCheckedAddons(scope) {
    var items = [];
    scope.querySelectorAll('[data-fairyland-addon]:checked').forEach(function (checkbox) {
      items.push({ id: Number(checkbox.dataset.variantId), quantity: 1 });
    });
    return items;
  }

  // Expresní platba (Apple Pay / Google Pay / Shop Pay) míří rovnou do pokladny
  // s obsahem formuláře, takže by samostatné doplňky nepobrala. Když si tedy
  // zákazník nějaký vybere, expresní tlačítka schováme a řekneme proč.
  function prepniExpresniPlatbu(box) {
    var vybrano = !!box.querySelector('[data-fairyland-addon]:checked');
    var scope = box.closest('product-form') || document;
    var expres = scope.querySelector('.shopify-payment-button');
    var poznamka = scope.querySelector('[data-fairyland-express-note]');
    if (expres) expres.hidden = vybrano;
    if (poznamka) poznamka.hidden = !vybrano;
  }

  function initProductUpsell() {
    document.querySelectorAll('[data-fairyland-upsell]').forEach(function (box) {
      box.querySelectorAll('input[data-fairyland-addon]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          prepniExpresniPlatbu(box);
        });
      });
      prepniExpresniPlatbu(box);
    });

    // po odeslání formuláře prstenu si zapamatujeme, co přidat po cart-update
    var pendingAddons = null;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      var scope = form.closest('product-form') || form;
      var upsellBox = scope.querySelector('[data-fairyland-upsell]');
      if (!upsellBox) return;
      var items = collectCheckedAddons(upsellBox);
      if (items.length) pendingAddons = items;
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!pendingAddons) return;
        if (event && event.source !== 'product-form') return;
        var items = pendingAddons;
        pendingAddons = null;
        addItemsToCart(items);
      });
    }
  }

  /* ---------- 2) upsell v cart draweru ---------- */

  function initDrawerUpsell() {
    // delegace — obsah draweru se přepisuje přes innerHTML
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-fairyland-drawer-add]');
      if (!button) return;
      event.preventDefault();
      var item = { id: Number(button.dataset.variantId), quantity: 1 };
      button.setAttribute('disabled', '');
      addItemsToCart([item], function () {
        button.removeAttribute('disabled');
      });
    });
  }

  /* ---------- 3) sticky lišta na mobilu ---------- */

  function initStickyBar() {
    var bar = document.querySelector('[data-fairyland-sticky]');
    if (!bar) return;

    var submitButton = document.getElementById(bar.dataset.submitId);
    if (!submitButton) return;

    document.body.classList.add('fairyland-has-sticky');

    bar.querySelector('[data-fairyland-sticky-submit]').addEventListener('click', function () {
      submitButton.click();
    });

    // lišta se ukáže, jakmile skutečné CTA zmizí nad horní hranu okna
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(submitButton);
  }

  /* ---------- 4) dynamický termín doručení ---------- */

  function initDeliveryDate() {
    var targets = document.querySelectorAll('[data-fairyland-delivery-date]');
    if (!targets.length) return;

    // expedice: pracovní den do 14:00, jinak nejbližší další pracovní den
    var date = new Date();
    if (date.getDay() === 0 || date.getDay() === 6 || date.getHours() >= 14) {
      do {
        date.setDate(date.getDate() + 1);
      } while (date.getDay() === 0 || date.getDay() === 6);
    }

    // doručení: Zásilkovna doručuje na výdejní místo den po podání (D+1) → +1 pracovní den od expedice.
    // Tím odhad sedí s příslibem „do 2 pracovních dnů“ všude na stránce.
    var added = 0;
    while (added < 1) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }

    var dayNames = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
    var label = dayNames[date.getDay()] + ' ' + date.getDate() + '. ' + (date.getMonth() + 1) + '.';

    targets.forEach(function (el) {
      el.textContent = 'Objednáš dnes → ' + label + ' ji má na ruce';
      el.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Jeden autorský moment: nákupní panel se po načtení usadí zdola.
  // Zbytek stránky zůstává statický, ať to nepůsobí jako karusel efektů.
  function initUsazeniPanelu() {
    var panel = document.querySelector('.product__info-container');
    if (!panel) return;
    panel.classList.add('fairyland-enter');
  }

  function init() {
    initUsazeniPanelu();
    initProductUpsell();
    initDrawerUpsell();
    initStickyBar();
    initDeliveryDate();
  }
})();
